import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const IntegrationsSection = ({ integrations, onConnect, onDisconnect }) => {
  return (
    <div className="bg-card rounded-xl shadow-md p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg">
          <Icon name="Plug" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            Connected Apps & Devices
          </h2>
          <p className="text-sm text-muted-foreground caption">
            Sync your fitness data
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {integrations?.map((integration, index) => (
          <div
            key={index}
            className={`p-4 md:p-6 rounded-lg border-2 transition-smooth ${
              integration?.connected
                ? 'bg-success/5 border-success' :'bg-muted/30 border-border'
            }`}
          >
            <div className="flex items-start justify-between gap-4 mb-4">
              <div className="flex items-center gap-3">
                <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${
                  integration?.connected ? 'bg-success/10' : 'bg-muted'
                }`}>
                  <Icon
                    name={integration?.icon}
                    size={24}
                    color={integration?.connected ? 'var(--color-success)' : 'var(--color-muted-foreground)'}
                  />
                </div>
                <div>
                  <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
                    {integration?.name}
                  </h3>
                  <p className="text-xs md:text-sm text-muted-foreground caption">
                    {integration?.description}
                  </p>
                </div>
              </div>
              {integration?.connected && (
                <div className="flex items-center justify-center w-6 h-6 bg-success text-success-foreground rounded-full flex-shrink-0">
                  <Icon name="Check" size={14} strokeWidth={3} />
                </div>
              )}
            </div>

            {integration?.connected && (
              <div className="mb-4 p-3 bg-card rounded-lg">
                <p className="text-xs text-muted-foreground caption mb-1">
                  Last synced
                </p>
                <p className="text-sm font-medium text-foreground">
                  {integration?.lastSync}
                </p>
              </div>
            )}

            <Button
              variant={integration?.connected ? 'outline' : 'default'}
              size="default"
              iconName={integration?.connected ? 'Unplug' : 'Plug'}
              iconPosition="left"
              onClick={() => integration?.connected ? onDisconnect(integration?.id) : onConnect(integration?.id)}
              fullWidth
            >
              {integration?.connected ? 'Disconnect' : 'Connect'}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationsSection;